import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../../menu/menuSlice";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

// categories
export const getCategory = createAsyncThunk("getCategory", async (id) => {
  const res = await axios.get(`/api/category?id=${id}`);
  return res.data;
});

export const getCategories = createAsyncThunk(
  "getCategories",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/category/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addCategory = createAsyncThunk(
  "addCategory",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { name, code } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ name, code });
      const res = await axios.post("api/category", body, config);
      successAlertHandle("Category added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateCategory = createAsyncThunk(
  "updateCategory",
  async ({ id, name, code }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ id, name, code });
      const res = await axios.put("api/category", body, config);
      successAlertHandle("Category updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteCategory = createAsyncThunk(
  "deleteCategory",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/category?id=${id}`);
      successAlertHandle("Category deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

// products
export const getProduct = createAsyncThunk("getProduct", async (id) => {
  const res = await axios.get(`/api/product?id=${id}`);
  return res.data;
});

export const getProducts = createAsyncThunk(
  "getProducts",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/product/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addProduct = createAsyncThunk(
  "addProduct",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const { code, name, unit, price, category } = data;
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ code, name, unit, price, category });
      const res = await axios.post("api/product", body, config);
      successAlertHandle("Product added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateProduct = createAsyncThunk(
  "updateProduct",
  async (
    { id, code, name, unit, price, category },
    { dispatch, rejectWithValue }
  ) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({ id, code, name, unit, price, category });
      const res = await axios.put("api/product", body, config);
      successAlertHandle("Product updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteProduct = createAsyncThunk(
  "deleteProduct",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/product?id=${id}`);
      successAlertHandle("Product deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

//hooks

export const getCategoriesNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/category/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const getProductsNoLimit = async () => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(`/api/product/filter`, body, config);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};
